import HeroMetadata from './customer/default/heroMetadata.component';

export default HeroMetadata;
